class GameDataStore extends SlotGame.src.store.GameData {
    public extra: {[key: string]: any} = {};

    setData(data: any) {
        super.setData(data);

        this.extra = data?.extra || {};

        this.setHoldPositionsWithReplaceSymbols();
    }

    setHoldPositionsWithReplaceSymbols() {
        this.holdPositions = this.replace.length ? this.getHoldPositionsWithReplaceSymbols() : this.holdPositions;
    }

    transformedHoldPositions(arr) {
        return arr.map(({ x, y, symbol }) => {
            if (symbol === 11) {
                return null;
            }
            return {
                from: [x, y],
                to: [x, y],
                symbol: symbol,
            };
        }).filter(position => position !== null);
    }

    getHoldPositionsWithReplaceSymbols() {
        return [
            ...this.holdPositions,
            ...this.transformedHoldPositions(this.replace)
        ]
    }
}

export {GameDataStore};

SlotGame.src.store.GameData = GameDataStore;